module.exports = __webpack_public_path__ + "static/media/detector.d6c3674a.svg";